class LoadMoreProducts {
	constructor() {
		this.$ = jQuery;
		this.loadMoreButton = this.$('#load-more-products');
		this.productsGrid = this.$('#products-grid');

		if (this.loadMoreButton.length) {
			this.init();
		}
	}

	init() {
		this.loadMoreButton.on('click', (e) => this.handleLoadMore(e));
	}

	handleLoadMore(e) {
		e.preventDefault();

		const button = this.$(e.currentTarget);
		const currentPage = parseInt(button.data('current-page'));
		const maxPages = parseInt(button.data('max-pages'));
		const taxonomy = button.data('taxonomy');
		const termId = button.data('term-id');
		const nextPage = currentPage + 1;

		// Add loading state
		button.addClass('loading opacity-50 cursor-wait');
		button.text('Laddar...');

		const postData = {
			action: 'load_more_products',
			paged: nextPage,
			taxonomy: taxonomy,
			term_id: termId
		};

		this.$.ajax({
			url: productLoadMore.ajax_url,
			method: 'POST',
			data: postData,
			dataType: 'json'
		})
		.done((response) => {
			if (response.success) {
				// Append each product with fade-in effect
				this.$.each(response.data.html, (key, html) => {
					this.$(html)
						.hide()
						.appendTo(this.productsGrid)
						.fadeIn(400);
				});

				// Update button state
				button.data('current-page', nextPage);
				button.removeClass('loading opacity-50 cursor-wait');
				button.text('Ladda fler produkter');

				// Hide button if we've reached the last page
				if (nextPage >= maxPages) {
					button.fadeOut(300);
				}
			} else {
				console.error('Load more failed:', response.data.message);
				button.removeClass('loading opacity-50 cursor-wait');
				button.text('Ladda fler produkter');
			}
		})
		.fail((xhr, status, error) => {
			console.error('AJAX error:', error);
			button.removeClass('loading opacity-50 cursor-wait');
			button.text('Ladda fler produkter');
		});
	}
}

export default LoadMoreProducts;
